<template>
<v-app style="height:100vh">
  <v-card color="background" @click="setActive" @mouseenter="setActive" @keyup="setActive" class="fill-height">
    <div v-if="!signedIn && this.$route.name !== 'EnrolTerminal' && (this.$route.name !== 'admin' && this.$route.name !== 'verify')" style="height:100vh">
      <div style="height:100vh">
        <Signin :callback="(value) => this.signedIn = value" :id="id" :imageUrl="imageUrl" :venue="venue"/>
        <!-- <amplify-authenticator :authConfig="{ signInConfig }" @input="onInputChange" :value="input" >
          <AmplifySignUp
            headerText="Custom form"
            :formFields="inputFields"
            slot="sign-up"
          />
        </amplify-authenticator> -->
      </div>
    </div>
    <div v-if="signedIn && (this.$route.name !== 'admin' && this.$route.name !== 'verify')">
      <AppNavigation :signedIn="signedIn" :signOut="signOut" :userName="user.username"/>
      
      <v-main>
        <Home v-if="signedIn && setToken !== null" :refetch="disconnected" :userName="user.username" />
      </v-main>
    </div>
    <div v-if="this.$route.name === 'EnrolTerminal'">
      <v-main>
        <EnrolTerminal />
      </v-main>
    </div>
    <div v-if="this.$route.name === 'admin'">
      <v-main>
        <Administrator :signedIn="signedIn" :signOut="signOut"/>
      </v-main>
    </div>
    <div v-if="this.$route.name === 'verify'">
      <v-main>
        <Verify :signedIn="signedIn" :signOut="signOut"/>
      </v-main>
    </div>
    <TerminalFailModal v-if="terminalFail" @close="terminalFailClose()" :terminalId="this.getTerminalId" :failMsg="this.terminalFailMsg"/>
    <v-snackbar
      :timeout="-1"
      :value="appVersion.stale"
      bottom
      left
      transition="none"
      color="warning"
      style="margin-bottom: 30px"
    >
      <b>An update is available.</b>
      <v-btn elevation="0"
        style="margin-left: 10px !important;"
        color="success"
        dark
        @click="refreshPage"
        :small = "!$vuetify.breakpoint.xl"
      >
        Update &amp; Reload
      </v-btn>
      <v-btn elevation="0"
        style="margin-left: 18px !important"
        color="primary"
        dark
        :small = "!$vuetify.breakpoint.xl"
        @click="dismissNotif"
      >
        Dismiss
      </v-btn>
    </v-snackbar>
    <v-btn
    style="position: absolute; bottom: 0; left: 0; margin: 20px;"
      v-if="debugModeOn"
      dark
      color="warning"
      @click="debugDialog = true"
    >
    <v-icon
        left
        dark
      >mdi-console
      </v-icon>

      DEBUG Console
      <v-badge floating v-if="consoleLogCount > 0" :content="consoleLogCount" color="error">
      </v-badge>
    </v-btn>
  </v-card>
  <DebugConsole :showDialog="debugDialog" @close="debugDialog = false"/>
  <v-dialog
      v-model="noCurrentUser"
      width="500"
      persistent
    >
      <v-card >
        <v-card-title class="text-h5 error white--text">
          User Session Timed Out
        </v-card-title>

        <v-card-text class="text-body-2 my-2">
          Current user session timed out, please log in again
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="sessionOut()"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</v-app>
</template>

<script>
import AppNavigation from './components/AppNavigation'
import Home from './views/Home'
import { mapActions, mapState, mapGetters } from 'vuex'
import { Auth, Hub } from 'aws-amplify'
import { subscriptionClient } from './vue-apollo'
import Signin from './views/Signin'
import {logo, SESSIONTIMEOUT, USERROLE, ticketLogo} from './common/constants'
import { setTicketHeader, setTicketOptions } from './common/tickets'
import { clearCustomerDisplay } from './common/customerDisplay'
import EnrolTerminal from './views/EnrolTerminal.vue'
import Administrator from './views/Administrator.vue'
import Verify from './views/Verify.vue'
import TerminalFailModal from './components/TerminalFailModal'
import { isUserHasAccessToVenue } from './common/methods'
import DebugConsole from './components/DebugConsole.vue'

export default {
  name: 'App',
  data() {
    return {
      signedIn: true,
      user: {},
      signInConfig: { header: 'Teller Terminals Sign-In', isSignUpDisplayed: false },
      subscriptionInitialised: false,
      disconnected: false,
      setToken: null,
      time: 0,
      interval: null,
      printerStatusHandler: null,
      printerStatusCB: null,
      debugDialog: false
    }
  },
  created(){
    document.title = process.env.VUE_APP_TITLE
  },
  computed: {
    ...mapState(['terminalFail', 'terminalFailMsg', 'appVersion','noCurrentUser','debugModeOn','axioRequestResponse']),
    ...mapGetters(['getTerminalId', 'hasFeature', 'getLastAuthUser']),
    id () {
      return this.$route.query.id?.replace(/_/g, ' ')
    },
    venue () {
      return this.$route.query.venue?.replace(/_/g, ' ')
    },
    imageUrl () {
      return logo[this.$route.query.venue]
    },
    ticketImageUrl () {
      return ticketLogo[this.$route.query.venue]
    },
    consoleLogCount(){
      return this.axioRequestResponse?.length
    }
  },
  components: {
    AppNavigation,
    Home,
    Signin,
    EnrolTerminal,
    Administrator,
    Verify,
    TerminalFailModal,
    DebugConsole
  },
  watch: {
    signedIn () {
      if (subscriptionClient && subscriptionClient.on && !this.subscriptionInitialised) {
          subscriptionClient.on('disconnected', () => {
            this.disconnected = true
            if (!this.signedIn) {
              subscriptionClient.reconnect = false
            } else {
              subscriptionClient.reconnect = true
            }
          })
          subscriptionClient.on('reconnected', () => {
            if (this.disconnected) {
              this.disconnected = false
              this.fetchMeetings()
            }
          })
          this.subscriptionInitialised = true
        }
    }
  },
  async mounted() {
    this.setTerminalId(decodeURIComponent(this.$route.query.id))
    this.setVenueName(this.$route.query.venue)
    this.startVersionPolling()
    setTicketHeader(this.ticketImageUrl);
    switch(this.$route.query.venue) {
      case "MN":
      case "monmouth":
        setTicketOptions({
          expirationString: "Tickets expire 1 year from purchase date"
        });
        break;
      default:
        setTicketOptions({});
        break;
    }
    this.updateDebugModeOn(this.$route.query.debug === 'true')
    try {
      await Auth.currentSession()
      await Auth.signOut()
      this.signedIn = false
    } catch {
      this.signedIn = false
    }
    if (window.rt?.initialize) {
      window.rt.initialize();
      if (window.cd) {
        window.cd.setLogo(this.imageUrl);
        clearCustomerDisplay();
      }
      window.rt.onTicketScanEvent((msg) => {
        console.log(`Scanned ticket: <${msg}>`);
      });
      let cbFunc = (msg) => {
        console.log(msg);
      }
      if (this.printerStatusCB && this.printerStatusHandler) {
        window?.rt.removePrinterStatusEventHandler(this.printerStatusHandler);
      }
      this.printerStatusHandler = window.rt.onPrinterStatusEvent(cbFunc);
      this.printerStatusCB = cbFunc;
      window.rt.onMagCardEvent((msg) => {
        console.log('magcard', msg);
        const tracks = JSON.parse(msg)
        this.setPlayerCardId(tracks[1]);
      });
    }
    Hub.listen('auth', async data => {
      try {
        // const testToken = 'DEMO-ALL'
        switch (data.payload.event) {
          case 'signIn':
            // do nothing if it is sign in via re-print authorise pop-up window
            if( this.getLastAuthUser && data.payload.data.username != this.getLastAuthUser){
              window.localStorage.setItem(`CognitoIdentityServiceProvider.${process.env.VUE_APP_COGNITO_CLIENT_ID}.LastAuthUser`,this.getLastAuthUser)
              return
            }
            if (this.$route.name !== 'admin' && this.$route.name !== 'verify') {
              this.user.username = data.payload.data.username
              this.signIn()
              this.setToken = `${this.$route.query.id} ${data.payload.data.signInUserSession?.accessToken?.jwtToken}`
              this.updateLastAuthUser(data.payload.data.username)
              this.updateLastAuthUserRole(parseInt(data.payload.data.attributes['custom:admin']) === 1 ? USERROLE.ADMIN : USERROLE.ENDUSER)
              this.signedIn = isUserHasAccessToVenue(data.payload.data.signInUserSession?.accessToken?.payload['cognito:groups']||[],this.venue)
            } else{
              this.signedIn = true
            }
            break;
          case 'signOut':
            this.signedIn = false;
            this.updateLastAuthUser(null)
            this.updateLastAuthUserRole(USERROLE.ENDUSER)
            break;
        }
      } catch (error) {
        console.log("1"+error)
      }
    });
    this.time = 0
    if (this.interval) {
      clearInterval(this.interval)
    }
    if (this.venue && SESSIONTIMEOUT[this.venue] !== 0) {
      const time = SESSIONTIMEOUT[this.venue]
      this.interval = setInterval(() => {
        this.time = this.time +1
        if (this.time >= 5) {
          Auth.signOut()
          this.signedIn = false
          this.time = 0
          // setTimeout(() => {
          //   window.alert('User signed out due to inactivity')
          // }, 500)
        }
      }, time)
    }
  },
  methods: {
    ...mapActions(['sessionOut','fetchMeetings','setTerminalId','signOut','signIn','setTerminalFail', 'setTerminalFailMsg', 'setVenueName', 'startVersionPolling', 'setPlayerCardId', 'updateLastAuthUser', 'updateLastAuthUserRole','updateDebugModeOn']),
    setActive () {
      this.time = 0;
    },
    terminalFailClose () {
      this.signOut()
      this.setTerminalFail(false)
      this.setTerminalFailMsg(null)
      this.signedIn = false
      window.location.reload()
    },
    async signOut () {
      this.signedIn = false;
      this.setToken = null
      await Auth?.signOut()
    },

    dismissNotif () {
      this.appVersion.stale = false
    },
    refreshPage () {
        window.location.reload() 
    },
  },
  beforeDestroy () {
    this.signedIn = false
    clearInterval(this.interval)
    this.time = 0
    if (this.printerStatusCB && this.printerStatusHandler && window.rt) {
        window?.rt.removePrinterStatusEventHandler(this.printerStatusHandler);
      }
  }
};
</script>

<style lang="sass">
</style>

<style>
/* width */
::-webkit-scrollbar {
  width: 6px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #435058;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #2c3941;
}

.v-ripple__container {
    display:none !important;
}


/*
  Theme: darkKeyboard
*/
.simple-keyboard.darkKeyboard {
  background-color: rgba(0, 0, 0, 0.8);
  border-radius: 0;
  border-bottom-right-radius: 5px;
  border-bottom-left-radius: 5px;
}

.simple-keyboard.darkKeyboard .hg-button {
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(67, 80, 88, 0.5);
  color: white;
}

.simple-keyboard.darkKeyboard .hg-button:active {
  background: #2196f3;
  color: white;
}

#root .simple-keyboard.darkKeyboard + .simple-keyboard-preview {
  background: #2196f3;
}

.hg-button{
  height: calc(calc(95vh - 467px)/5) !important;
  max-height: 60px !important;
}

.hg-layout-numeric .hg-button{
  height: 60px !important
}
</style>
